module.exports = __webpack_public_path__ + "img/folders.7141f976.png";